import React from 'react';
import { Button, Flex, Heading } from "@magnetic/core";
import { Notification } from "@magnetic/notification";
import { Text } from "@magnetic/text";
import { Input } from "@magnetic/input";

type UserCodeInputProps = {
  userCode: string;
  userCodeError: string,
  setUserCode: (userCode: string) => void;
  handleCancel: () => void;
  validateUserCode: () => void;
}

const UserCodeInput = ({
    userCode,
    userCodeError,
    setUserCode,
    handleCancel,
    validateUserCode
  }: UserCodeInputProps) => {

  return (
        <Flex direction="vertical" gap="lg" className="device-auth-flex">
          <Flex direction="vertical">
            <Heading>Code confirmation</Heading>
            <Text color="light">
              Confirm or enter the code displayed on your monitor.
            </Text>
          </Flex>
          <Flex direction="vertical" gap={8}>
            <Input
              label="Code"
              value={userCode}
              onChange={(e) => setUserCode(e.target.value)}
              invalid={!!userCodeError}
              data-testid="user-code-input"
            />
            {userCodeError && (
              <Notification status="negative">{userCodeError}</Notification>
            )}
          </Flex>
          <Flex justify="flex-end" style={{ marginTop: "30px" }}>
            <Button.Group>
              <Button kind="tertiary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                kind="primary"
                onClick={validateUserCode}
                disabled={!userCode}
              >
                Confirm
              </Button>
            </Button.Group>
          </Flex>
        </Flex>
  );
};

export default UserCodeInput;